<template lang="pug">
ib-col(class="pick-industries insetx-32 xl4", :class="{ 'insety-16 border-top': !$media.xl }")
    div(class="corporate_industries")
        div(class="outsety-16")
            label(class="bold bond-title fg70") {{ $t('industries') }}
        ul
            li(v-for="(e,i) in industries", class="after-16")
                ib-checkbox(:name="e.name", v-model="e.checked")
                    span(class="outsetx-8 fs6 fg50") {{ e.name }}
        ib-button(class="link" @click="selectAll", v-model="isSelectAll") {{ $t('select_all') }}/{{ $t('none') }}

</template>

<script>
    import mxGb from '../mixin/mixin-global'
    export default {
        name: 'Industries',

        mixins: [ mxGb ],

        data() {
           return {
             industries: [
                { id: "Energy", name: this.$t('energy'), checked: true },
                { id: "Basic Materials", name: this.$t('basic_materials'), checked: true },
                { id: "Industrial", name: this.$t('industrial'), checked: true },
                { id: "Consumer, Cyclical", name: this.$t('consumer_cyclical'), checked: true },
                { id: "Consumer, Non-cyclical", name: this.$t('consumer_noncyclical'), checked: true },
                { id: "Financial", name: this.$t('financial'), checked: true },
                { id: "Technology", name: this.$t('technology'), checked: true },
                { id: "Communications", name: this.$t('telecommunication_services'), checked: true },
                { id: "Utilities", name: this.$t('utilities'), checked: true },
             ],
             isSelectAll: true
           }
        },

        watch: {
            industries: {
                deep: true,
                handler: function(newVal, oldVal) {
                    this.updateIndustries();
                }
            }
        },

        methods: {
            selectAll() {
                this.isSelectAll = !this.isSelectAll;
                if (this.isSelectAll) {
                    for (var i = 0; i < this.industries.length; i++) {
                        this.industries[i].checked = true;
                    }
                } else {
                    for (var i = 0; i < this.industries.length; i++) {
                        this.industries[i].checked = false;
                    }
                }
                this.$emit('onChange', '');
            },
            updateIndustries() {
                let selectedIndustries = [];
                for (let i = 0; i < this.industries.length; i++) {
                    const obj = this.industries[i];
                    if (obj.checked) {
                       selectedIndustries.push(obj.name);
                    }
                }
                if (selectedIndustries.length === 0 || selectedIndustries.length === this.industries.length) {
                    this.$emit('onChange', '');
                } else {
                    const ret = selectedIndustries.join('#');
                    this.$emit('onChange', ret);
                }
            }
        },

        mounted() {
            this.$nextTick(() => {
                this.$emit('onChange', '');
                if (this.subFilters) {
                    const selectedInd = this.getFilterValue('industryLike') || "";
                    if (selectedInd) {
                        const indArray = selectedInd.split('#');
                        this.industries.forEach(i => {
                            i.checked = indArray.includes(i.id);
                        });
                    }
                }
            });
        }
    }
</script>

<style, lang="less">
.pick-industries ul {
    padding-left: 0;
    list-style-type: none;
}

</style>